import React from 'react';

export function EstimatePriceColumnFormatter(cellContent) {
  const getValue = () => {
    const {
      shumaTypeID,
      originTypeID,
      estimatePriceFinalRounded,
      finalMarketPrice,
      propertyPriceMinusDepreciation,
      estimatePriceFinal
    } = cellContent;

    if (originTypeID === 3) {
      return estimatePriceFinal
        ? Math.floor(estimatePriceFinal)
        : '';
    } else {
      switch (shumaTypeID) {
        case 1:
          return estimatePriceFinalRounded
            ? Math.floor(estimatePriceFinalRounded)
            : '';
        case 2:
          return finalMarketPrice
            ? Math.floor(finalMarketPrice)
            : '';
        case 3:
        case 4:
          return propertyPriceMinusDepreciation
            ? Math.floor(propertyPriceMinusDepreciation)
            : '';
        default:
          return estimatePriceFinal
            ? Math.floor(estimatePriceFinal)
            : '';
      }
    }
  };

  return (
    <div className="text-dark-75 font-weight-bolder d-block font-size-h5 text-nowrap">
      {getValue().toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0})}
    </div>
  );
}
